import * as Realm from "realm-web";
import { app } from "./app.js";

// /
export function loginAnonymous() {
  //
  // Allow users to log in anonymously
  return app.logIn(Realm.Credentials.anonymous());
}

export function hasLoggedInUser() {
  // Check if there is currently a logged in user
  return (
    app.currentUser &&
    app.currentUser.isLoggedIn &&
    app.currentUser.providerType !== "anon-user"
  );
}

export function getCurrentUser() {
  // Return the user object of the currently logged in user
  return hasLoggedInUser() ? app.currentUser : null;
}

export function logoutCurrentUser() {
  // Logout the currently logged in user
  return app.currentUser.logOut();
}

export function addAuthenticationListener(listener) {
  app.auth.addAuthListener(listener);
}
export function removeAuthenticationListener(listener) {
  app.auth.removeAuthListener(listener);
}

export function handleOAuthRedirects() {
  if (app.auth.hasRedirectResult()) {
    return app.auth.handleRedirectResult();
  }
}
